import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4f8f42fe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8f42fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f8f42fe')) {
      api.createRecord('4f8f42fe', component.options)
    } else {
      api.reload('4f8f42fe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4f8f42fe&scoped=true", function () {
      api.rerender('4f8f42fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/msg/index.vue"
export default component.exports